import isFutureDate from './is-future-date';

export { isFutureDate };

export default isFutureDate;
